import React from 'react';
import {
  CapaQuotationChatMessage,
  CapaQuotationChatMessageSimpleQuotation,
  CapaQuotationChatMessageDetailedQuotation,
  CapaQuotationChatMessageType
} from '@generated/graphql';

import PriceIconImg from '../../assets/PriceIconImg.png';

import { formatCurrency } from '@utils/formatter';

import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import { clsx } from '@components/Provider';

import { Divider, Grid } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';

import useStyles from '../useStyles';

import { useHistory } from 'react-router-dom';
import { useSelector } from '@store';

interface Props {
  message?: CapaQuotationChatMessage;
}

const QuotationBubble: React.FC<Props> = ({ message }) => {
  const classes = useStyles();
  const history = useHistory();

  const { hasProgressingPayment, isOld } = useSelector((state) => state.chat);
  const isTraking = !hasProgressingPayment && !isOld;

  const messageType = message?.message?.messageType ?? undefined;
  const isSimple = messageType === CapaQuotationChatMessageType.SimpleQuotation;
  const chatMessage = (message?.message ?? undefined) as
    | CapaQuotationChatMessageSimpleQuotation
    | CapaQuotationChatMessageDetailedQuotation;
  const quotation = chatMessage.quotation?.quotation ?? 0;
  const excludeDeliveryFee = chatMessage.quotation?.excludeDeliveryFee ?? false;
  const etc = chatMessage.quotation?.etc ?? undefined;

  const onClick = () =>
    history.push(
      history.location.pathname + `?menu=quotation${isTraking ? '&p=1' : ''}`
    );

  return (
    <Grid
      className={clsx(classes['Chat-Message-Bubble-Common-root'], {
        owner: true,
        'quotation-bubble': true
      })}
      container
    >
      <div className="title">
        <img src={PriceIconImg} alt="icon" />
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          fontWeight="bold"
        >
          {isSimple ? '간편 견적가' : '상세 견적가'}
        </CustomizedTypography>
      </div>
      <CustomizedTypography variant="subtitle2" color="textSecondary">
        VAT 별도의 견적가입니다.
      </CustomizedTypography>
      <Divider className="divider" />
      <Grid container justifyContent="space-between" alignItems="center">
        <CustomizedTypography
          variant="subtitle2"
          color="textSecondary"
          gutterBottoms={10}
        >
          배송비
        </CustomizedTypography>
        <CustomizedTypography
          variant="subtitle2"
          color="primary"
          gutterBottoms={10}
        >
          {excludeDeliveryFee ? '별도 ' : '포함 '}
        </CustomizedTypography>
      </Grid>
      <Grid container justifyContent="space-between" alignItems="center">
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          예상금액
        </CustomizedTypography>
        <CustomizedTypography variant="body1" color="primary" fontWeight="bold">
          총 {formatCurrency(quotation)}원
        </CustomizedTypography>
      </Grid>
      {etc && isSimple ? (
        <React.Fragment>
          <Divider className="divider" />
          <CustomizedTypography className="long-text" variant="body2">
            {etc}
          </CustomizedTypography>
        </React.Fragment>
      ) : null}
      {!isSimple && (
        <React.Fragment>
          <Divider className="divider" />
          <CustomizedButton
            variant="outlined"
            color="primary"
            startIcon={<img src={PriceIconImg} alt="icon" />}
            endIcon={<ChevronRight fontSize="small" />}
            classes={{
              label: 'buttonLabel',
              startIcon: 'startIcon'
            }}
            fullWidth
            onClick={onClick}
          >
            상세 견적서 확인하기
          </CustomizedButton>
        </React.Fragment>
      )}
    </Grid>
  );
};

export default QuotationBubble;
